// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid-module--grid--1CWo4","grid__container":"grid-module--grid__container--1S8yQ"};